
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34444',
  depVersions: {
  "documents-public-ui": "static-1.34444",
  "client-types": "static-1.466",
  "documents-lib": "static-1.34449",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2111",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4994",
  "highcharts": "static-8.103",
  "hs-promise-utils": "static-1.5572",
  "hs-test-utils": "static-1.7990",
  "hub-http": "static-1.6198",
  "hubspot-dlb": "static-2.1845",
  "HubStyleTokens": "static-2.11444",
  "I18n": "static-7.1617",
  "jasmine-immutable": "static-1.2997",
  "jasmine-runner": "static-1.6443",
  "lodash": "static-1.3",
  "quartz": "static-1.6995",
  "react": "static-7.185",
  "react-dlb": "static-1.78",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16645",
  "reporting-data": "static-1-jbartola_hubspot-replace-checked-ts.90",
  "reporting-testing-lib": "static-1-jbartola_hubspot-replace-checked-ts.90",
  "reporting-visualizations": "static-1-jbartola_hubspot-replace-checked-ts.90",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4744",
  "webpack-env": "static-1.54",
  "atom": "static-1.5048",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2474",
  "classnames": "static-2.10",
  "cssUtils": "static-1.786",
  "customer-data-filters-ui": "static-1.39663",
  "customer-data-objects": "static-1.7639",
  "customer-data-property-utils": "static-1.8064",
  "data-fetching-client": "static-1.9648",
  "enviro": "static-4.446",
  "FireAlarmUi": "static-1.4493",
  "flux-actions": "static-1.331",
  "FormsCommonComponents": "static-1.85764",
  "FormUrlGenerator": "static-2.4695",
  "foundations-components": "static-1.7883",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4115",
  "HubStyle": "static-2.11751",
  "icons": "static-2.644",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7135",
  "metrics-js": "static-1.9619",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.397",
  "property-description-translator": "static-1.3822",
  "property-translator": "static-1.5377",
  "quartz-config": "static-1.773",
  "quartz-core": "static-1.6214",
  "quick-fetch": "static-1.3896",
  "raven": "static-3.5907",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-select-plus": "static-1.104",
  "react-utils": "static-2.5324",
  "react-virtualized": "static-2.98",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8145",
  "reference-resolvers-lite": "static-1.8071",
  "report-customization-components": "static-1.13088",
  "reporting-enablement": "static-1.22824",
  "reporting-reports": "static-1-jbartola_hubspot-replace-checked-ts.90",
  "reporting-snowflake": "static-1-jbartola_hubspot-replace-checked-ts.90",
  "reporting-ui-components": "static-2-jbartola_hubspot-replace-checked-ts.90",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4628",
  "sales-content-partitioning": "static-1.8916",
  "SalesContentIndexUI": "static-3.9204",
  "sanitize": "static-1.4454",
  "sanitize-text": "static-1.8119",
  "self-service-api": "static-1.10223",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1724",
  "signup-constants": "static-1.18797",
  "signup-ui-lego-core": "static-1.20807",
  "signup-ui-url-generator": "static-2.8019",
  "styled-components": "static-2.89",
  "StyleGuideUI": "static-3.486",
  "superstore": "static-1.4741",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10969",
  "ui-addon-i18n": "static-1.11128",
  "ui-addon-react-router-dom": "static-1.9520",
  "ui-addon-upgrades": "static-9.17949",
  "ui-asset-management-lib": "static-1.10990",
  "ui-images": "static-2.1147",
  "UIComponents": "static-3.8390",
  "usage-tracker": "static-1.7322",
  "usage-tracker-container": "static-1.7312",
  "usage-tracker-core": "static-1.7172",
  "usage-tracker-public": "static-1.7133",
  "viral-links-lib": "static-1.7033",
  "hs-promise-rejection-tracking": "static-1.5566",
  "raven-hubspot": "static-1.6214",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3384",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3272",
  "quartz-webpack": "static-1.3219",
  "ai-components-ui-library": "static-1.8872",
  "amplitude-session-replay-browser": "static-1.59",
  "foundations-assets": "static-1.4840",
  "foundations-theming": "static-1.4395",
  "quartz-auth": "static-1.670",
  "ui-business-units-lib": "static-1.9026",
  "usage-tracker-session-replay": "static-1.5008",
  "foundations-theming-base": "static-1.3380",
  "HeadJS": "static-2.752",
  "framer-motion": "static-1.71",
  "hs-test-utils-bend-plugin": "static-1.3101",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "hs-locale-management": "static-1.65",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4303",
  "csstype": "static-1.50",
  "quartz-head": "static-1.660",
  "web-vitals": "static-1.4",
  "frontend-preferences-client": "static-1.7905",
  "graphql": "static-1.81",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3570",
  "persist-promise": "static-1.3673",
  "quartz-i18n": "static-1.670",
  "reporting-client-types": "static-1.2496",
  "foundations-components-legacy": "static-1.908",
  "hs-story-utils": "static-1.9404",
  "react-flip-move": "static-1.69",
  "hub-http-shared-msw-handlers": "static-1.9900",
  "hubspotter-http": "static-1.4632",
  "sassPrefix": "static-1.155",
  "events-data-lib": "static-1.192",
  "conversations-skeleton-state": "static-1.7224",
  "crm-message-bus": "static-1.42919",
  "customer-data-filters-ui-msw-helpers": "static-1.22098",
  "customer-data-objects-ui-components": "static-1.13001",
  "customer-data-reference-ui-components": "static-1.13136",
  "customer-data-ui-utilities": "static-1.9802",
  "framework-builder-read-service-client": "static-1.3989",
  "framework-data-schema-quick-fetch": "static-1.6764",
  "framework-data-schema-resolvers": "static-1.6859",
  "inbound-db-properties-service-client": "static-1.3826",
  "multi-account-reference-resolvers": "static-1.954",
  "onboarding-tours": "static-1.16549",
  "reporting-datasets-permissions-lib": "static-1.13603",
  "ui-addon-teams": "static-1.21510",
  "apollo-stack-hubspot": "static-3.85",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68282",
  "customer-data-properties": "static-1.51450",
  "forms-ai-lib": "static-1.4280",
  "forms-utils-lib": "static-1.12528",
  "foundations-components-test-utils": "static-1.5366",
  "react-dnd-compat": "static-1.4596",
  "react-tinymce": "static-1.55166",
  "tinymce-config": "static-2.54292",
  "ui-gdpr-components": "static-1.10323",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4152",
  "floating-ui": "static-1.55",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.15",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1790",
  "ui-fonts": "static-1.706",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.830",
  "mobile-manifest-mixins": "static-1.527",
  "module-federation": "static-1.22",
  "quartz-routing": "static-1.425",
  "quartz-test": "static-1.670",
  "quartz-tracking": "static-1.374",
  "batch-promise": "static-1.1516",
  "external-options-client-types": "static-1.4138",
  "react-colorpicker": "static-2.10186",
  "ui-addon-draggable-compat": "static-2.4231",
  "copilot-toolkit": "static-1.11069",
  "data-quality-ui-library": "static-1.12915",
  "html-to-image": "static-1.53",
  "onboarding-scopes": "static-1.6438",
  "reporting-action-components": "static-1.41232",
  "reporting-filters": "static-1.271",
  "reporting-insights-lib": "static-1.1659",
  "reporting-plugins": "static-1.10283",
  "ui-addon-opt": "static-4.8348",
  "zustand": "static-1.74",
  "growth-payments-core": "static-1.25296",
  "hubspot-apollo-client": "static-1.4853",
  "bend-plugin-chirp-manifest": "static-1.38",
  "chirp-fetch": "static-1.1863",
  "sales-templates-service-types-lib": "static-1.4150",
  "merchandise-lib": "static-1.263",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5840",
  "salesImages": "static-1.524",
  "ts-schema": "static-1.4060",
  "nested-table": "static-1.203",
  "timezone-utils": "static-2.5221",
  "bender-build-tools": "static-1.3171",
  "chatspot-core": "static-1.21161",
  "bend-plugin-foundations-theming": "static-1.2878",
  "stylex": "static-1.32",
  "hubspotter-http-shared-msw-handlers": "static-1.9898",
  "hs-resources": "static-1.129",
  "pulse": "static-1.547",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3777",
  "crm-pipelines-api-client-types": "static-1.4122",
  "multi-currency-client-types": "static-1.3671",
  "getting-started-shared-tasks": "static-1.18428",
  "growth-data-modal": "static-1.5388",
  "growth-onboarding-confetti": "static-1.3043",
  "growth-onboarding-next-action-utils": "static-1.1843",
  "navigation-components": "static-1.17958",
  "onboarding-tours-client": "static-1.4763",
  "onboarding-tours-utils": "static-1.615",
  "ui-shepherd-react": "static-3.10133",
  "ui-shepherd-tracker": "static-1.7514",
  "ui-universal-auth": "static-1.8948",
  "user-context": "static-1.5079",
  "cms-field-types": "static-1.4788",
  "content-icons-ui": "static-1.2220",
  "integrations-lib": "static-1.16026",
  "calling-global-api": "static-1.64426",
  "calling-internal-common": "static-1.31278",
  "calling-lifecycle-internal": "static-1.65808",
  "calling-lifecycle-messages": "static-1.58102",
  "commerce-products-lib": "static-1.9460",
  "crm-links": "static-1.6261",
  "customer-data-properties-shared-msw-handlers": "static-1.9227",
  "file-manager-components": "static-1.23547",
  "google-libphonenumber": "static-1.37",
  "inbounddb-objects-service-types": "static-1.4203",
  "meetings-icalendar-utils-lib": "static-1.608",
  "object-builder-ui-client": "static-1.48644",
  "pipeline-validation-client-types": "static-1.3945",
  "property-value-citations": "static-1.2064",
  "smart-property-lib": "static-1.6791",
  "tiered-pricing": "static-1.1145",
  "ui-addon-iframeable": "static-1.9033",
  "final-form": "static-1.69",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19783",
  "tinymce-themes": "static-1.56262",
  "data-token-picker": "static-1.16361",
  "hub-http-contrib": "static-1.3018",
  "interframe": "static-3.4737",
  "tinymce-data": "static-1.40377",
  "tinymce-plugins": "static-1.57406",
  "ui-addon-sales-email": "static-1.5187",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "magpie-lib": "static-1.5538",
  "magpie-types": "static-1.4998",
  "simple-logging-lib": "static-1.3025",
  "content-assistance-lib": "static-1.7712",
  "dashboard-lib": "static-1.81415",
  "ExportDialog": "static-6.10368",
  "hubspot-prosemirror": "static-1.18168",
  "hubspot-prosemirror-plugins": "static-1.18160",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8680",
  "campaign-roi-lib": "static-1.9007",
  "feedback-loader": "static-1.29247",
  "apollo-link-hub-http": "static-2.4626",
  "hubspot-apollo-cache": "static-1.312",
  "purchase-motions-api": "static-1.5843",
  "trials-service-types": "static-1.3879",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.149",
  "markdown-it": "static-1.6",
  "bend-plugin-pulse": "static-1.50",
  "directed-graph": "static-1.911",
  "event-emitter": "static-1.924",
  "fast-json-patch": "static-1.62",
  "onboarding-data-sync-lib": "static-1.1917",
  "growth-onboarding-next-action-components": "static-1.1871",
  "user-context-client": "static-1.4588",
  "idb-keyval": "static-1.43",
  "nest": "static-1.203",
  "reactive-lib": "static-1.698",
  "unified-auth-core-lib": "static-1.744",
  "getting-started-shared-tasks-store": "static-1.17546",
  "integrations-error-boundary-lib": "static-1.13441",
  "integrations-tracking-lib": "static-1.5575",
  "native-integrations-shared-strings": "static-1.7759",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10346",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.462",
  "calling-error-reporting": "static-1.31285",
  "shared-worker-versioning": "static-1.11014",
  "calling-usage-tracker": "static-1.6519",
  "voice-sms-access-library": "static-1.870",
  "customer-data-tracking": "static-1.6864",
  "commerce-permissions": "static-1.743",
  "products-iframe-lib": "static-1.7857",
  "products-ui-components-shared-msw-handlers": "static-1.10282",
  "location-customization-utils-lib": "static-1.9170",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4130",
  "video-components-external": "static-1.11182",
  "video-data-lib": "static-1.34840",
  "data-agent-kit": "static-1.153",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9983",
  "fsm": "static-1.3707",
  "policy-lib": "static-1.6754",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10046",
  "navigation-messaging": "static-1.7285",
  "FileManagerLib": "static-1.39187",
  "NamespacedHubStyle": "static-2.9041",
  "FileManagerCore": "static-1.39046",
  "codemirror": "static-5.94",
  "layout-dnd-components": "static-1.12395",
  "layout-dnd-utils": "static-1.11370",
  "react-codemirror": "static-1.10601",
  "ui-addon-emoji-picker": "static-1.9865",
  "ui-brand-identity-lib": "static-1.15160",
  "ui-addon-video-player": "static-1.8679",
  "ui-coaching-tips": "static-1.28475",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8483",
  "payment-link-components": "static-1.23459",
  "EmailSignatureEditor": "static-1.24312",
  "breeze-engine-lib": "static-1.536",
  "InboxConnectUtils": "static-4.14739",
  "universal-page-editor-lib": "static-1.2989",
  "google-sheets-integration-lib": "static-1.156",
  "microsoft-drive-integration-lib": "static-1.272",
  "calling-orchestration-schema": "static-1.35647",
  "sales-views-client-types": "static-1.4240",
  "crm-record-cards-service-types": "static-1.3587",
  "content-media-composition-data-lib": "static-1.12169",
  "content-media-compositions": "static-2.16176",
  "media-bridge-lib": "static-1.18879",
  "trellis-story-utils": "static-1.4492",
  "storybook-react": "static-1.32",
  "audio-components": "static-1.5877",
  "FileManagerImages": "static-1.36698",
  "video-components": "static-1.13185",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4513",
  "video-embed": "static-1.35674",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68357",
  "layout-data-lib": "static-1.9695",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6558",
  "commerce-tours-lib": "static-1.6045",
  "growth-onboarding-reliability": "static-1.5059",
  "sales-checkout-service-client": "static-1.3616",
  "draft-convert": "static-2.72",
  "draft-extend": "static-3.74",
  "draft-js": "static-5.77",
  "draft-plugins": "static-2.21627",
  "sales-email-signature-service-client": "static-1.3819",
  "ably": "static-2.2",
  "social-insights-client-types": "static-1.22008",
  "outpost": "static-1.4162",
  "advanced-menus-core": "static-1.15090",
  "advanced-menus-lib": "static-1.12035",
  "ui-memberships-settings-lib": "static-1.33972",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15089",
  "simple-menus-lib": "static-1.16606"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34444",
  "client-types": "/client-types/static-1.466",
  "documents-lib": "/documents-lib/static-1.34449",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2111",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4994",
  "highcharts": "/highcharts/static-8.103",
  "hs-promise-utils": "/hs-promise-utils/static-1.5572",
  "hs-test-utils": "/hs-test-utils/static-1.7990",
  "hub-http": "/hub-http/static-1.6198",
  "hubspot-dlb": "/hubspot-dlb/static-2.1845",
  "HubStyleTokens": "/HubStyleTokens/static-2.11444",
  "I18n": "/I18n/static-7.1617",
  "jasmine-immutable": "/jasmine-immutable/static-1.2997",
  "jasmine-runner": "/jasmine-runner/static-1.6443",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6995",
  "react": "/react/static-7.185",
  "react-dlb": "/react-dlb/static-1.78",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16645",
  "reporting-data": "/reporting-data/static-1-jbartola_hubspot-replace-checked-ts.90",
  "reporting-testing-lib": "/reporting-testing-lib/static-1-jbartola_hubspot-replace-checked-ts.90",
  "reporting-visualizations": "/reporting-visualizations/static-1-jbartola_hubspot-replace-checked-ts.90",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4744",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.5048",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2474",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.786",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39663",
  "customer-data-objects": "/customer-data-objects/static-1.7639",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8064",
  "data-fetching-client": "/data-fetching-client/static-1.9648",
  "enviro": "/enviro/static-4.446",
  "FireAlarmUi": "/FireAlarmUi/static-1.4493",
  "flux-actions": "/flux-actions/static-1.331",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85764",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4695",
  "foundations-components": "/foundations-components/static-1.7883",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4115",
  "HubStyle": "/HubStyle/static-2.11751",
  "icons": "/icons/static-2.644",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7135",
  "metrics-js": "/metrics-js/static-1.9619",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.397",
  "property-description-translator": "/property-description-translator/static-1.3822",
  "property-translator": "/property-translator/static-1.5377",
  "quartz-config": "/quartz-config/static-1.773",
  "quartz-core": "/quartz-core/static-1.6214",
  "quick-fetch": "/quick-fetch/static-1.3896",
  "raven": "/raven/static-3.5907",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-select-plus": "/react-select-plus/static-1.104",
  "react-utils": "/react-utils/static-2.5324",
  "react-virtualized": "/react-virtualized/static-2.98",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8145",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8071",
  "report-customization-components": "/report-customization-components/static-1.13088",
  "reporting-enablement": "/reporting-enablement/static-1.22824",
  "reporting-reports": "/reporting-reports/static-1-jbartola_hubspot-replace-checked-ts.90",
  "reporting-snowflake": "/reporting-snowflake/static-1-jbartola_hubspot-replace-checked-ts.90",
  "reporting-ui-components": "/reporting-ui-components/static-2-jbartola_hubspot-replace-checked-ts.90",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4628",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8916",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9204",
  "sanitize": "/sanitize/static-1.4454",
  "sanitize-text": "/sanitize-text/static-1.8119",
  "self-service-api": "/self-service-api/static-1.10223",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1724",
  "signup-constants": "/signup-constants/static-1.18797",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20807",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8019",
  "styled-components": "/styled-components/static-2.89",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "superstore": "/superstore/static-1.4741",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10969",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11128",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9520",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17949",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10990",
  "ui-images": "/ui-images/static-2.1147",
  "UIComponents": "/UIComponents/static-3.8390",
  "usage-tracker": "/usage-tracker/static-1.7322",
  "usage-tracker-container": "/usage-tracker-container/static-1.7312",
  "usage-tracker-core": "/usage-tracker-core/static-1.7172",
  "usage-tracker-public": "/usage-tracker-public/static-1.7133",
  "viral-links-lib": "/viral-links-lib/static-1.7033",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5566",
  "raven-hubspot": "/raven-hubspot/static-1.6214",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3384",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3272",
  "quartz-webpack": "/quartz-webpack/static-1.3219",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8872",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "foundations-assets": "/foundations-assets/static-1.4840",
  "foundations-theming": "/foundations-theming/static-1.4395",
  "quartz-auth": "/quartz-auth/static-1.670",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9026",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5008",
  "foundations-theming-base": "/foundations-theming-base/static-1.3380",
  "HeadJS": "/HeadJS/static-2.752",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3101",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "hs-locale-management": "/hs-locale-management/static-1.65",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4303",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.660",
  "web-vitals": "/web-vitals/static-1.4",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7905",
  "graphql": "/graphql/static-1.81",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3570",
  "persist-promise": "/persist-promise/static-1.3673",
  "quartz-i18n": "/quartz-i18n/static-1.670",
  "reporting-client-types": "/reporting-client-types/static-1.2496",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.908",
  "hs-story-utils": "/hs-story-utils/static-1.9404",
  "react-flip-move": "/react-flip-move/static-1.69",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9900",
  "hubspotter-http": "/hubspotter-http/static-1.4632",
  "sassPrefix": "/sassPrefix/static-1.155",
  "events-data-lib": "/events-data-lib/static-1.192",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7224",
  "crm-message-bus": "/crm-message-bus/static-1.42919",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22098",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13001",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13136",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9802",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3989",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6764",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6859",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3826",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.954",
  "onboarding-tours": "/onboarding-tours/static-1.16549",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13603",
  "ui-addon-teams": "/ui-addon-teams/static-1.21510",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68282",
  "customer-data-properties": "/customer-data-properties/static-1.51450",
  "forms-ai-lib": "/forms-ai-lib/static-1.4280",
  "forms-utils-lib": "/forms-utils-lib/static-1.12528",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5366",
  "react-dnd-compat": "/react-dnd-compat/static-1.4596",
  "react-tinymce": "/react-tinymce/static-1.55166",
  "tinymce-config": "/tinymce-config/static-2.54292",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10323",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4152",
  "floating-ui": "/floating-ui/static-1.55",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.15",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1790",
  "ui-fonts": "/ui-fonts/static-1.706",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.830",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.527",
  "module-federation": "/module-federation/static-1.22",
  "quartz-routing": "/quartz-routing/static-1.425",
  "quartz-test": "/quartz-test/static-1.670",
  "quartz-tracking": "/quartz-tracking/static-1.374",
  "batch-promise": "/batch-promise/static-1.1516",
  "external-options-client-types": "/external-options-client-types/static-1.4138",
  "react-colorpicker": "/react-colorpicker/static-2.10186",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4231",
  "copilot-toolkit": "/copilot-toolkit/static-1.11069",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12915",
  "html-to-image": "/html-to-image/static-1.53",
  "onboarding-scopes": "/onboarding-scopes/static-1.6438",
  "reporting-action-components": "/reporting-action-components/static-1.41232",
  "reporting-filters": "/reporting-filters/static-1.271",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1659",
  "reporting-plugins": "/reporting-plugins/static-1.10283",
  "ui-addon-opt": "/ui-addon-opt/static-4.8348",
  "zustand": "/zustand/static-1.74",
  "growth-payments-core": "/growth-payments-core/static-1.25296",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4853",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.38",
  "chirp-fetch": "/chirp-fetch/static-1.1863",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4150",
  "merchandise-lib": "/merchandise-lib/static-1.263",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5840",
  "salesImages": "/salesImages/static-1.524",
  "ts-schema": "/ts-schema/static-1.4060",
  "nested-table": "/nested-table/static-1.203",
  "timezone-utils": "/timezone-utils/static-2.5221",
  "bender-build-tools": "/bender-build-tools/static-1.3171",
  "chatspot-core": "/chatspot-core/static-1.21161",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2878",
  "stylex": "/stylex/static-1.32",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9898",
  "hs-resources": "/hs-resources/static-1.129",
  "pulse": "/pulse/static-1.547",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3777",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4122",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3671",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18428",
  "growth-data-modal": "/growth-data-modal/static-1.5388",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3043",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1843",
  "navigation-components": "/navigation-components/static-1.17958",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4763",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.615",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10133",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7514",
  "ui-universal-auth": "/ui-universal-auth/static-1.8948",
  "user-context": "/user-context/static-1.5079",
  "cms-field-types": "/cms-field-types/static-1.4788",
  "content-icons-ui": "/content-icons-ui/static-1.2220",
  "integrations-lib": "/integrations-lib/static-1.16026",
  "calling-global-api": "/calling-global-api/static-1.64426",
  "calling-internal-common": "/calling-internal-common/static-1.31278",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65808",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58102",
  "commerce-products-lib": "/commerce-products-lib/static-1.9460",
  "crm-links": "/crm-links/static-1.6261",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9227",
  "file-manager-components": "/file-manager-components/static-1.23547",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4203",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.608",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48644",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3945",
  "property-value-citations": "/property-value-citations/static-1.2064",
  "smart-property-lib": "/smart-property-lib/static-1.6791",
  "tiered-pricing": "/tiered-pricing/static-1.1145",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9033",
  "final-form": "/final-form/static-1.69",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19783",
  "tinymce-themes": "/tinymce-themes/static-1.56262",
  "data-token-picker": "/data-token-picker/static-1.16361",
  "hub-http-contrib": "/hub-http-contrib/static-1.3018",
  "interframe": "/interframe/static-3.4737",
  "tinymce-data": "/tinymce-data/static-1.40377",
  "tinymce-plugins": "/tinymce-plugins/static-1.57406",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5187",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "magpie-lib": "/magpie-lib/static-1.5538",
  "magpie-types": "/magpie-types/static-1.4998",
  "simple-logging-lib": "/simple-logging-lib/static-1.3025",
  "content-assistance-lib": "/content-assistance-lib/static-1.7712",
  "dashboard-lib": "/dashboard-lib/static-1.81415",
  "ExportDialog": "/ExportDialog/static-6.10368",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18168",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18160",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8680",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9007",
  "feedback-loader": "/feedback-loader/static-1.29247",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4626",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.312",
  "purchase-motions-api": "/purchase-motions-api/static-1.5843",
  "trials-service-types": "/trials-service-types/static-1.3879",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.149",
  "markdown-it": "/markdown-it/static-1.6",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.50",
  "directed-graph": "/directed-graph/static-1.911",
  "event-emitter": "/event-emitter/static-1.924",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1917",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1871",
  "user-context-client": "/user-context-client/static-1.4588",
  "idb-keyval": "/idb-keyval/static-1.43",
  "nest": "/nest/static-1.203",
  "reactive-lib": "/reactive-lib/static-1.698",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.744",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17546",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13441",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5575",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7759",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10346",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.462",
  "calling-error-reporting": "/calling-error-reporting/static-1.31285",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11014",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6519",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.870",
  "customer-data-tracking": "/customer-data-tracking/static-1.6864",
  "commerce-permissions": "/commerce-permissions/static-1.743",
  "products-iframe-lib": "/products-iframe-lib/static-1.7857",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10282",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9170",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4130",
  "video-components-external": "/video-components-external/static-1.11182",
  "video-data-lib": "/video-data-lib/static-1.34840",
  "data-agent-kit": "/data-agent-kit/static-1.153",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9983",
  "fsm": "/fsm/static-1.3707",
  "policy-lib": "/policy-lib/static-1.6754",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10046",
  "navigation-messaging": "/navigation-messaging/static-1.7285",
  "FileManagerLib": "/FileManagerLib/static-1.39187",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9041",
  "FileManagerCore": "/FileManagerCore/static-1.39046",
  "codemirror": "/codemirror/static-5.94",
  "layout-dnd-components": "/layout-dnd-components/static-1.12395",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11370",
  "react-codemirror": "/react-codemirror/static-1.10601",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9865",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15160",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8679",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28475",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "payment-link-components": "/payment-link-components/static-1.23459",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24312",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.536",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14739",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2989",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.156",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.272",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35647",
  "sales-views-client-types": "/sales-views-client-types/static-1.4240",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3587",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12169",
  "content-media-compositions": "/content-media-compositions/static-2.16176",
  "media-bridge-lib": "/media-bridge-lib/static-1.18879",
  "trellis-story-utils": "/trellis-story-utils/static-1.4492",
  "storybook-react": "/storybook-react/static-1.32",
  "audio-components": "/audio-components/static-1.5877",
  "FileManagerImages": "/FileManagerImages/static-1.36698",
  "video-components": "/video-components/static-1.13185",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4513",
  "video-embed": "/video-embed/static-1.35674",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68357",
  "layout-data-lib": "/layout-data-lib/static-1.9695",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6558",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6045",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5059",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3616",
  "draft-convert": "/draft-convert/static-2.72",
  "draft-extend": "/draft-extend/static-3.74",
  "draft-js": "/draft-js/static-5.77",
  "draft-plugins": "/draft-plugins/static-2.21627",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3819",
  "ably": "/ably/static-2.2",
  "social-insights-client-types": "/social-insights-client-types/static-1.22008",
  "outpost": "/outpost/static-1.4162",
  "advanced-menus-core": "/advanced-menus-core/static-1.15090",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12035",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33972",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15089",
  "simple-menus-lib": "/simple-menus-lib/static-1.16606"
}
};
